import type { ReaderName } from "@bindery/shared/contracts/session";

export function readerDisplayName(reader: ReaderName): string {
  return reader.readerNickname ?? "Reader";
}
